import { AccountPermission } from 'modules/permissions/constants';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAppSelector } from 'store/useAppSelector';
import { useCheckAccountPermission } from 'modules/account/hooks/useCheckAccountPermission';

import { selectHasJwtManagerAccess } from '../store/selectors';
import { useAllowedJWTsCount } from './useAllowedJWTsCount';

export const useJWTManagerPermissions = () => {
  const { group } = useAccount();

  const hasAccess = useAppSelector(state =>
    selectHasJwtManagerAccess(state, { group }),
  );

  const {
    allowedJWTsCount,
    allowedJWTsCountState: { isSuccess: isAllowedJWTsCountLoaded },
    isLoading: allowedJWTsCountLoading,
  } = useAllowedJWTsCount({ skipFetching: true });

  const hasGroupAccessToReadJwtManager = useCheckAccountPermission({
    permission: AccountPermission.JwtManagerRead,
  });

  const hasGroupAccessToWriteJwtManager = useCheckAccountPermission({
    permission: AccountPermission.JwtManagerWrite,
  });

  return {
    allowedJWTsCount,
    allowedJWTsCountLoading,
    hasReadAccess: hasAccess && hasGroupAccessToReadJwtManager,
    hasWriteAccess: hasAccess && hasGroupAccessToWriteJwtManager,
    isAllowedJWTsCountLoaded,
  };
};
